import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";

import {maxWidth} from "@pg-design/helpers-css";
import {flex, mr, mt} from "@pg-design/helpers-css/index";
import {Link} from "@pg-design/link-module/index";
import {Text} from "@pg-design/text/index";
import {rpAppLink} from "@pg-mono/rp-routes";
import {investmentOffer, numberFormat, promotionOfferPluralize, propertyOffer} from "@pg-mono/string-utils";

import {IRPStore} from "../../app/rp_reducer";
import {SeoMainHeadline} from "../../atoms/SeoMainHeadline";
import {ToggleMapButton} from "../../offer/map/components/ToggleMapButton";
import {buildFriendlyPromotionSlug} from "../../promotion/helpers/build_friendly_promotion_slug";
import {InvestmentOfferListBreadcrumbs} from "../components/InvestmentOfferListBreadcrumbs";
import {investmentOfferCities} from "../constants/investment_offer_constants";
import {IParsedInvestmentOfferCategories} from "../list/actions/parse_investment_offer_url";
import {getInvestmentOffersHeader} from "../list/utils/get_investment_offers_header";

interface IProps {
    categories: IParsedInvestmentOfferCategories;
    className?: string;
    pageTitle: string;
    linkUrl?: string;
    propertiesCount: number | null;
    offerCount: number;
    isMap?: boolean;
    region: string | null;
    offerType?: number;
    page?: number;
}

export const InvestmentOfferHeader = (props: IProps) => {
    const {categories, pageTitle, propertiesCount, offerCount, offerType} = props;

    const theme = useTheme();

    const regionId = useSelector((state: IRPStore) => state.investmentOffer.list.offers.latestQuery.region);
    const stats = useSelector((state: IRPStore) => state.investmentOffer.stats);

    const promotionCounter = stats && regionId && typeof regionId === "number" ? stats.by_region[regionId].promotions_count_total : null;

    const promotionListingLink =
        props.region && investmentOfferCities.some(({slug}) => slug === props.region)
            ? rpAppLink.promotions.listFriendly({friendlySlug: buildFriendlyPromotionSlug({region: props.region})})
            : rpAppLink.promotions.list();

    const header = getInvestmentOffersHeader(categories, pageTitle, offerType);

    const renderPromotionCounterButton = () => {
        if (promotionCounter && promotionCounter >= 5) {
            return (
                <Link href={promotionListingLink}>
                    {" "}
                    w tym {promotionCounter} {promotionOfferPluralize(promotionCounter)}
                </Link>
            );
        }

        return null;
    };

    return (
        <section className={props.className} css={[flex("center", "space-between")]}>
            <header css={maxWidth("100%")}>
                {!props.isMap && <InvestmentOfferListBreadcrumbs />}

                <SeoMainHeadline
                    as="h1"
                    variant={props.isMap ? "headline_6" : "headline_2"}
                    highlight
                    prefixContent={header.prefix}
                    pageString={props?.page && props.page > 1 ? ` - Strona ${props.page}` : ""}
                >
                    {header.text}
                </SeoMainHeadline>

                {!!propertiesCount && (
                    <Text color={theme.colors.gray[700]} css={mt(2)} variant={props.isMap ? "info_txt_1" : "body_copy_1"}>
                        Znaleziono {numberFormat(propertiesCount)} {propertyOffer.nominative(propertiesCount)} w {numberFormat(offerCount)}{" "}
                        {investmentOffer.locative(offerCount)}
                        {renderPromotionCounterButton()}
                    </Text>
                )}
            </header>

            {!props.isMap && props.linkUrl && <ToggleMapButton css={mapButton} isMap={props.isMap} linkUrl={props.linkUrl} />}
        </section>
    );
};

const mapButton = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.md}) {
        ${mt(0)};
        ${mr(5)};
    }
`;
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";

import {maxWidth} from "@pg-design/helpers-css";
import {flex, mr, mt} from "@pg-design/helpers-css/index";
import {Link} from "@pg-design/link-module/index";
import {Text} from "@pg-design/text/index";
import {rpAppLink} from "@pg-mono/rp-routes";
import {investmentOffer, numberFormat, promotionOfferPluralize, propertyOffer} from "@pg-mono/string-utils";

import {IRPStore} from "../../app/rp_reducer";
import {SeoMainHeadline} from "../../atoms/SeoMainHeadline";
import {ToggleMapButton} from "../../offer/map/components/ToggleMapButton";
import {buildFriendlyPromotionSlug} from "../../promotion/helpers/build_friendly_promotion_slug";
import {InvestmentOfferListBreadcrumbs} from "../components/InvestmentOfferListBreadcrumbs";
import {investmentOfferCities} from "../constants/investment_offer_constants";
import {IParsedInvestmentOfferCategories} from "../list/actions/parse_investment_offer_url";
import {getInvestmentOffersHeader} from "../list/utils/get_investment_offers_header";

interface IProps {
    categories: IParsedInvestmentOfferCategories;
    className?: string;
    pageTitle: string;
    linkUrl?: string;
    propertiesCount: number | null;
    offerCount: number;
    isMap?: boolean;
    region: string | null;
    offerType?: number;
    page?: number;
}

export const InvestmentOfferHeader = (props: IProps) => {
    const {categories, pageTitle, propertiesCount, offerCount, offerType} = props;

    const theme = useTheme();

    const regionId = useSelector((state: IRPStore) => state.investmentOffer.list.offers.latestQuery.region);
    const stats = useSelector((state: IRPStore) => state.investmentOffer.stats);

    const promotionCounter = stats && regionId && typeof regionId === "number" ? stats.by_region[regionId].promotions_count_total : null;

    const promotionListingLink =
        props.region && investmentOfferCities.some(({slug}) => slug === props.region)
            ? rpAppLink.promotions.listFriendly({friendlySlug: buildFriendlyPromotionSlug({region: props.region})})
            : rpAppLink.promotions.list();

    const header = getInvestmentOffersHeader(categories, pageTitle, offerType);

    const renderPromotionCounterButton = () => {
        if (promotionCounter && promotionCounter >= 5) {
            return (
                <Link href={promotionListingLink}>
                    {" "}
                    w tym {promotionCounter} {promotionOfferPluralize(promotionCounter)}
                </Link>
            );
        }

        return null;
    };

    return (
        <section className={props.className} css={[flex("center", "space-between")]}>
            <header css={maxWidth("100%")}>
                {!props.isMap && <InvestmentOfferListBreadcrumbs />}

                <SeoMainHeadline
                    as="h1"
                    variant={props.isMap ? "headline_6" : "headline_2"}
                    highlight
                    prefixContent={header.prefix}
                    pageString={props?.page && props.page > 1 ? ` - Strona ${props.page}` : ""}
                >
                    {header.text}
                </SeoMainHeadline>

                {!!propertiesCount && (
                    <Text color={theme.colors.gray[700]} css={mt(2)} variant={props.isMap ? "info_txt_1" : "body_copy_1"}>
                        Znaleziono {numberFormat(propertiesCount)} {propertyOffer.nominative(propertiesCount)} w {numberFormat(offerCount)}{" "}
                        {investmentOffer.locative(offerCount)}
                        {renderPromotionCounterButton()}
                    </Text>
                )}
            </header>

            {!props.isMap && props.linkUrl && <ToggleMapButton css={mapButton} isMap={props.isMap} linkUrl={props.linkUrl} />}
        </section>
    );
};

const mapButton = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.md}) {
        ${mt(0)};
        ${mr(5)};
    }
`;
